import React from 'react'

const InfoTitle = (props) => {
	return <h3 className={"fc-title fc-title__blue " + props.classNames}>{props.text}</h3>
}

export default InfoTitle